<script>
import { mapState, mapGetters } from 'vuex';
import { getCurrencySymbol } from '@/utils';
import AppProgressbar from '@/common/AppProgressbar.vue';

export default {
  name: 'FundraiserStats',
  components: {
    AppProgressbar
  },

  data: () => ({
    errorLoadingAvatar: false,
    getCurrencySymbol
  }),
  computed: {
    ...mapState('fundraiser', {
      fundraiser: (state) => state
    }),
    ...mapState('campaign', {
      campaign: (state) => state
    }),
    ...mapGetters('fundraiser', ['fundraiserFullName']),
    progressPercentage() {
      if (this.unitBased) {
        const percentage = (100 / this.fundraiser.goal) * this.fulfilledUnits;
        return Math.min(percentage, 100);
      }
      const percentage = (100 / this.fundraiser.goal) * this.fundraiser.raised;
      return Math.min(percentage, 100);
    },
    avatarPath() {
      if (!this.fundraiser.avatarUrl || this.errorLoadingAvatar) {
        return false;
      }
      return `${this.fundraiser.avatarUrl}?${Date.now()}`;
    },
    // TEMP: support for DG
    campaignGoalMeter() {
      return this.campaign.settings.goalMeter;
    },
    unitBased() {
      // we rely on the campaign settings! it's sort of custom for DG
      return this.campaignGoalMeter.type === 'units';
    },
    fulfilledUnits() {
      // goal is used as unit goal
      return Math.floor(this.fundraiser.raised / this.campaignGoalMeter.unitCost);
    }
  },
  watch: {
    'fundraiser.avatarUrl'() {
      this.errorLoadingAvatar = false;
    }
  },
  methods: {
    handleAvatarError() {
      this.errorLoadingAvatar = true;
    }
  }
};
</script>

<template>
  <div class="fundraiser-stats my-4">
    <div class="stats flex text-primary-text">
      <div class="avatar">
        <img v-if="avatarPath" :src="avatarPath" alt="Fundraiser avatar" class="object-contain" @error="handleAvatarError" />
        <app-icon v-else type="svg" width="56" name="avatar-placeholder" />
      </div>
      <div class="flex-1 flex flex-col justify-between">
        <h2>{{ fundraiserFullName }}</h2>
        <div class="flex-col subtext-regular">
          <template v-if="unitBased" class="flex">
            <span
              ><span class="font-bold">{{ fulfilledUnits }} {{ campaignGoalMeter.unitName }}</span> / {{ fundraiser.goal }}</span
            >
            <span> Raised</span>
          </template>
          <template v-else>
            <span>Has raised </span>
            <span>{{ getCurrencySymbol(campaign.currency) }}</span>
            <span v-if="!unitBased" class="font-bold">{{ fundraiser.raised | currency }}</span>
            <span class="text-off-white"> / {{ getCurrencySymbol(campaign.currency) }}{{ fundraiser.goal | number }}</span>
          </template>
        </div>

        <app-progressbar :value="progressPercentage" />
      </div>
    </div>
  </div>
</template>
